import { observable, action, computed } from 'mobx';
import { ReqInputMsg, Addition, callCmd } from 'lib/reqInputMsg';
import { Storage } from 'lib/storage';
import { notification } from 'antd';

export default class CommonStore {
  constructor(root) {
    this.root = root;
  }
  //----------------------------------
  @observable
  _sessionLoginInfo = null;

  @computed
  get sessionLoginInfo() {
    return this._sessionLoginInfo;
  }

  @action
  onSessionCheck = () => {
    const loginInfo = Storage.session.get('loginInfo');
    console.log('onSessionCheck', loginInfo);
    if (loginInfo !== undefined) {
      this._sessionLoginInfo = {
        ...loginInfo,
        // 20230108 로그인정보에 회사구분값이 없으면 에러나서 기본 정보가 있을때 삼성으로 강제 셋팅 임시
        // 유빈 - 밑에 코드가 유진매니저로 로그인 후, 새로 고침을 누르면 nGbn이 L로 바뀌어서 막아놨는데, 오류 생길시 풀기 
        //cGbn : (loginInfo.cGbn === undefined || loginInfo.cGbn === null) ? "S" : "L"
      };

    }
  }

  @action
  onSessionOut = () => {
    console.log('onSessionOut!!!!');
    Storage.session.remove('loginInfo');
    this._sessionLoginInfo = null;
  }

  @action
  disLoginInfo = async (loginInfo) => {
    let addition = new Addition();
    addition.setCmdName('DIS-LOGIN-INFO');

    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);
    reqInputMsg.addParam({paraName: 'ceCd', paraValue: loginInfo.ceCd});
    reqInputMsg.addParam({paraName: 'cePw', paraValue: loginInfo.cePw});

    return await callCmd(reqInputMsg, 'centerInfo')
      .then((res) => {
        if (res.error.code === '0000') {
          if (res.result !== undefined && res.result !== null) {
            if (res.result.length > 0) {
              if (res.result[0].ceCd !== undefined && res.result[0].ceCd !== null) {
                notification.success({placement: 'bottomLeft', message: `${res.result[0].ceNm}님 안녕하세요.`, duration: 2});
                Storage.session.set("loginInfo", res.result[0]);
                this._sessionLoginInfo = res.result[0];
                this.disNoticePopList();
                if (loginInfo.remember === true) {
                  Storage.local.set("yujin_ceCd", loginInfo.ceCd);
                  Storage.local.set("yujin_cePw", loginInfo.cePw);
                } else {
                  Storage.local.remove("yujin_ceCd");
                  Storage.local.remove("yujin_cePw");
                }
              }
            } else {
              notification.error({placement: 'bottomLeft', message: `없는 아이디 또는 잘못된 비밀번호입니다.`, duration: 2});
            }
          }
        } else {
          notification.error({placement: 'bottomLeft', message: `아이디 혹은 비밀번호를 다시 한 번 확인해 주세요.`, duration: 2});
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`로그인이 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.` });
        console.log('error', error);
      });
  };

  @action
  disLogoutInfo = async () => {
    let addition = new Addition();
    addition.setCmdName('DIS-LOGOUT-INFO');

    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);
    
    return await callCmd(reqInputMsg, 'centerInfo')
      .then((res) => {
        if (res.error.code === '0000') {
          notification.success({placement: 'bottomLeft', message: `로그아웃이 되었습니다.`, duration: 2});
          if (Storage.session.get('loginInfo')) {
            Storage.session.remove('loginInfo');
          }
          this._sessionLoginInfo = null;
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`로그아웃이 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.` });
        console.log('error', error);
      });
  };


  @action
  onSessionOut = () => {
    // 로그인이 처음 부터 안된 상태일 때만 메시지를 띄운다.
    if (this._sessionLoginInfo !== null) {
      notification.error({placement: 'bottomLeft', message: `세션이 만료되었습니다. 다시 로그인 해주세요.`, duration: 2});
    }
    console.log('onSessionOut!!!!');
    Storage.session.remove('loginInfo');
    this._sessionLoginInfo = null;
  }
  
  //----------------------------------
  /* 공지사항 팝업 */
  @observable
  _popNoticeList = [];

  @computed
  get popNoticeList() {
    return this._popNoticeList;
  }

  @action
  disNoticePopList = async () => {
    let addition = new Addition();
    addition.setCmdName('DIS-NOTICEPOP-LIST');

    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);

    return await callCmd(reqInputMsg, 'board')
      .then((res) => {
        if (res.error.code === '0000') {
          if (res.result !== undefined && res.result !== null) {
            if (res.result.length > 0) {
              this._popNoticeList = res.result;
            }
          }
        }
      }).catch((error) => {
        console.log('error', error);
      });
  };

  //----------------------------------
  /* 마이페이지 */

  @action
  modPwInfo = async (cePw, cePwNew) => {
    let addition = new Addition();
    addition.setCmdName('MOD-PW-INFO');

    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);
    reqInputMsg.addParam({paraName: 'cePw', paraValue: cePw});
    reqInputMsg.addParam({paraName: 'cePwNew', paraValue: cePwNew});

    return await callCmd(reqInputMsg, 'centerInfo')
      .then((res) => {
        if (res.error.code === '0000') {
          if (res.result[0].resultMsg) {
            notification.success({placement: 'bottomLeft', message:`비밀번호 변경에 성공하였습니다.`, duration: 2});
          } else {
            notification.success({placement: 'bottomLeft', message:`비밀번호 변경에 실패하였습니다. 비밀번호를 확인하세요.`, duration: 2});
          }
        } else if (res.error.code === '0003') {
          this.onSessionOut();
        } else {
          notification.success({placement: 'bottomLeft', message:`비밀번호 변경에 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        console.log('error', error);
      });
  };

  //----------------------------------
  /* 지사 센터 셀렉트박스 리스트  */
  @observable
  _branchOption = [];

  @computed
  get branchOption() {
    return this._branchOption;
  }

  // 정렬순서 하드코딩
  @computed
  get branchOptionOrder() {
    return [
      {ceCd: 'AAI'},	   // 서울지사	
      {ceCd: 'AAK'},     // 경인지사	
      {ceCd: 'AAD'},     // 경원지사	
      {ceCd: 'AAC'},     // 중부지사	
      {ceCd: 'AAE'},     // 서부지사	
      {ceCd: 'AAG'},     // 경북지사	
      {ceCd: 'AAF'},     // 남부지사	
      {ceCd: 'AXE'},     // B2B서비스팀
      {ceCd: 'AAA'},     // 고객상담팀	
      {ceCd: 'AA0'}      // 삼성전자서비스
    ];
  }

  @action
  disBranchOption = async () => {
    let addition = new Addition();
    addition.setCmdName('DIS-CENTER-LIST');
    
    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);
    reqInputMsg.addParam({paraName: 'ceType', paraValue: 'B'});

    return await callCmd(reqInputMsg, 'centerInfo')
      .then((res) => {
        if (res.error.code === '0000') {
          // notification.success({placement: 'bottomLeft', message:`조회가 성공하였습니다.`, duration: 2});
          this._branchOption = res.result;
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.error({placement: 'bottomLeft', message:`지사 리스트를 불러오는데 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
          this._branchOption = [];
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`조회가 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        this._branchOption = [];
        console.log('error', error);
      });

    
  };
  
  // 센터 목록
  @observable
  _centerOption = [];

  @computed
  get centerOption() {
    return this._centerOption;
  }

  @action
  disCenterOption = async (ceBranchCd, ceNm) => {
    if (ceBranchCd === '') {
      this._centerOption = [];
      return;
    }
    let addition = new Addition();
    addition.setCmdName('DIS-CENTER-LIST');
    
    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);
    reqInputMsg.addParam({paraName: 'ceBranchCd', paraValue: ceBranchCd});
    reqInputMsg.addParam({paraName: 'ceType', paraValue: 'C'});

    if (ceNm !== undefined && ceNm !== null && ceNm !== '') {
      reqInputMsg.addParam({paraName: 'ceNm', paraValue: ceNm});
    }

    return await callCmd(reqInputMsg, 'centerInfo')
      .then((res) => {
        if (res.error.code === '0000') {
          // notification.success({placement: 'bottomLeft', message:`조회가 성공하였습니다.`, duration: 2});
          this._centerOption = res.result;
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.error({placement: 'bottomLeft', message:`센터 리스트를 불러오는데 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
          this._centerOption = [];
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`조회가 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        this._centerOption = [];
        console.log('error', error);
      });
  };
}
  
